export default "__VITE_ASSET__nJ2ldzeI__"